import type { Msg } from './types';

let held: Msg[] | null = null;

/** AskDock → màn toàn trang: đặt hội thoại hiện tại để `/ask` nhận lại (cùng messages, không gọi lại mô hình). */
export function setAskHandoff(messages: Msg[]): void {
  held = messages.length ? messages : null;
}

/** Xem hội thoại đã chuyển sang (không xoá — an toàn khi khởi tạo state chạy hai lần ở StrictMode); gọi `clearAskHandoff` trong effect. */
export function peekAskHandoff(): Msg[] | null {
  return held;
}

export function clearAskHandoff(): void {
  held = null;
}
